<template>
  <div
    class="visitor-welcome-wrap"
    :style="bgColor"
  >
    <visitor-login
      v-if="requireWhiteListing"
      @callback="visitorLoginCallback"
    />
    <template v-else>
      <transition name="fade">
        <div
          v-if="currentModal !== 'login'"
          class="visitor-welcome"
          @click.self="closeHandler"
        >
          <VisitorProfileMobile class="visitor-profile-mobile-position" />
          <div class="visitor-welcome-container bg-light">
            <visitor-step1
              v-show="visitorPageStep === 1"
              @callback="visitorStep1Callback"
            />
            <visitor-step2
              v-show="visitorPageStep === 2"
              ref="visitorStep2"
            />
          </div>
          <VisitorProfileDesktop
            v-if="!requireWhiteListing"
            class="visitor-profile-position"
          />
        </div>
      </transition>
    </template>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import gaEvents from '@/api/ga-events'
import VisitorLogin from './VisitorLogin'
import VisitorStep1 from './VisitorStep1'
import VisitorStep2 from './VisitorStep2'
import visitorArrowLeft from './img/visitor-arrow-left.svg'
import visitorArrowRight from './img/visitor-arrow-right.svg'
import VisitorProfileDesktop from './VisitorProfile/VisitorProfileDesktop'
import VisitorProfileMobile from './VisitorProfile/VisitorProfileMobile'

export default {
  name: 'VisitorWelcome',
  components: {
    VisitorProfileDesktop,
    VisitorProfileMobile,
    VisitorLogin,
    VisitorStep1,
    VisitorStep2
  },
  data () {
    return {
      visitorArrowLeft,
      visitorArrowRight
    }
  },
  computed: {
    ...mapState('vrlounge', [
      'currentModal'
    ]),
    ...mapGetters([
      'user',
      'currentBuilding',
      'property',
      'visitorPageStep'
    ]),
    requireWhiteListing () {
      return this.currentBuilding.requireWhiteListing
    },
    requireVisitorData () {
      return this.currentBuilding.requireVisitorData
    },
    bgColor () {
      if (this.requireVisitorData || this.requireWhiteListing) {
        return {
          backgroundColor: 'rgba(0, 0, 0, .6)'
        }
      }
      return null
    }
  },
  mounted () {
    if (this.$route.query.recordPilot) {
      this.closeVisitor()
    }
  },
  methods: {
    ...mapActions([
      'setVisitorPageStep',
      'closeVisitor'
    ]),
    async visitorLoginCallback (loginResult) {
      const currentBuildingId = this.currentBuilding.objectId
      gaEvents.sendEvent('Visitor', 'visitorLoginSuccessful', currentBuildingId)
      this.closeVisitor()
    },

    visitorStep1Callback (payload) {
      console.log('visitorStep1Callback', payload)
      this.setVisitorPageStep(2)
    },
    closeHandler () {
      if (this.requireVisitorData || this.requireWhiteListing) return
      this.closeVisitor()
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
@import '~css/addon/main';
@import '~css/common/extends';

.visitor-welcome-wrap {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 5;
}

.visitor-welcome {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  @media (min-width: $response) {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.visitor-profile-mobile-position {
  @media (min-width: $response) {
    display: none;
  }
}

.visitor-welcome-container {
  position: absolute
  top: 14.43% // .visitor-profile-mobile height
  bottom: 0
  padding: 20px
  min-width: 400px
  max-width: 100vw
  display: flex
  flex-direction: column

  .isif-close {
    position: absolute;
    cursor: pointer;
    top: 1rem;
    right: 1rem;
    font-size: 1.2rem;
  }

  @media (min-width: $response) {
    position: relative
    top: auto
    bottom: auto
    height: auto
    max-height: 100vh
    max-width: 600px
  }

  @media (max-width: $response-xs) {
    max-height: 100vh
    min-width: 100%
  }
}

.visitor-profile-position {
  display: none;

  @media (min-width: $response) {
    display: block;
  }
}

.bg-dark {
  display: flex
  align-items: center
  background-color: rgba(0,0,0,0.8)
}
.bg-light {
  display: flex
  align-items: center
  background-color: $white;

  @media (min-width: $response) {
    box-shadow: 2px 0 30px 0 rgba(163, 163, 163, 0.5);
  }
}
</style>
